// extracted by mini-css-extract-plugin
module.exports = {"asc-app":"AscLink_asc-app__GI1NZ","dark-mode":"AscLink_dark-mode__n2aT5","ground":"AscLink_ground__PpIry","button":"AscLink_button__nP8uc","disabled":"AscLink_disabled__ahmhy"};